import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {TabContent, TabPane, Nav, NavItem, NavLink, Row, Col} from 'reactstrap';
import QuantidadePercentualSolicitacaoForaPrazoDivisaoDepartamentoStore from "../stores/QuantidadePercentualSolicitacaoForaPrazoDivisaoDepartamentoStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";
import {CustomBarChart} from "../../comum/components/CustomBarChart";
import {CustomPieChart} from "../../comum/components/CustomPieChart";
import classnames from 'classnames';

const FILTROS = ['AREA', 'CENTRAL', 'DIVISAO', 'COMPETENCIA_INICIO', 'COMPETENCIA_FIM', 'PRODUTO'];

@inject("store")
@DataWrapper
@observer
export class QuantidadePercentualSolicitacaoForaPrazoDivisaoDepartamento extends Component {
    constructor(props) {
        super(props);
        this.controller = new QuantidadePercentualSolicitacaoForaPrazoDivisaoDepartamentoStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Quantidade e percentual de solicitações fora do prazo por divisão e departamento");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <MensagemErro>
                        {this.controller.erro}
                    </MensagemErro>
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                history={this.props.history}
                                controller={this.controller}
                                location={this.props.location}
                                fields={FILTROS} />
                        { this.controller.dados && this.controller.dados.length > 0 &&
                            <div>
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink onClick={() => { this.controller.toggle('1'); }}
                                            className={classnames({ active: this.controller.activeTab === '1' })} >
                                            Quantidade
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink onClick={() => { this.controller.toggle('2'); }}
                                            className={classnames({ active: this.controller.activeTab === '2' })} >
                                            Percentual
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={this.controller.activeTab}>
                                    <TabPane tabId="1">
                                        <Row>
                                            <Col xs={12} md={12} lg={10}>
                                                <CustomBarChart stackId="1" dataKeys={this.controller.departamentos} data={this.controller.dados}
                                                        labelAxisX={"Divisão"} labelAxisY={"Quantidade"} />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Row>
                                            <Col xs={12} md={12} lg={10}>
                                                <CustomPieChart dataKey="Quantidade" data={this.controller.dadosNaoTratados}
                                                        onClick={() => {}}/>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                </TabContent>
                            </div>
                        }
                        { this.controller.dados && this.controller.dados.length === 0 &&
                            <span>Nenhum resultado encontrado</span>
                        }
                    </LoadingBlockFields>
                </div>
            </div>
        )
    }
}
